import type { SVGProps } from 'react';
const SvgCreateNewFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#create_new_folder_svg__a)">
      <path
        fill="currentColor"
        d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2Zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2Z"
      />
    </g>
    <defs>
      <clipPath id="create_new_folder_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCreateNewFolder;
